import { connect } from 'react-redux'
import Sidebar from '../../../../common/containers/Sidebar'
import Card from '../../../../common/containers/Card'
import { Route, Routes } from 'react-router'
import LocationList from './LocationList'
import LocationEdit from './LocationEdit'
import { useState } from 'react'

let LocationPage = () => {
    const [pageAttr, setPageAttr] = useState({})

    return (
        <Sidebar>
            <Card {...pageAttr}>
                <Routes>
                    <Route path='/edit/:id' element={<LocationEdit setPageAttr={setPageAttr} />} />
                    <Route path='/add' element={<LocationEdit setPageAttr={setPageAttr} />} />
                    <Route path='/' element={<LocationList setPageAttr={setPageAttr} />} />
                </Routes>
            </Card>
        </Sidebar>
    )
}

export default connect()(LocationPage)